import { DurationSeconds } from 'lib/datetime/durationInSeconds'

const trackerName = 'sp'

const Snowplow = {
  trackerName,
  domainUserIdCookie: `lux_${trackerName}_domain_user_id`,
  sessionIdCookie: `lux_${trackerName}_session_id`,
  sessionIdxCookie: `lux_${trackerName}_session_idx`,
  postPath: '/com.luxgroup/tp2',
}
export default Snowplow

// Snowplow renews browser-storage expiry on activity; this does not rotate identities.
export function getSnowplowCookieLifetime(consentRequired: boolean): number {
  return consentRequired ? DurationSeconds.ONE_YEAR : DurationSeconds.TWO_YEARS
}
